import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=c890c672&scoped=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"
import style0 from "./Points.vue?vue&type=style&index=0&id=c890c672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c890c672",
  null
  
)

export default component.exports